<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" floating temporary>
      <v-list-item
        class="font-weight-bold text-center text-h5"
        title="SIBANGKOM"
        subtitle="ASN"
      ></v-list-item>
      <v-divider></v-divider>
      <v-list density="compact" nav>
        <v-list-item
          color="primary"
          v-for="m in menu"
          :key="m.link"
          :to="m.link"
          :title="m.name"
          :value="m.name"
        ></v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <NuxtLink :to="'/login'" style="text-decoration: none">
            <v-btn block color="primary">
              Masuk <v-icon>mdi-logout</v-icon></v-btn
            >
          </NuxtLink>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      height="80"
      scroll-behavior="elevate"
      :color="appBarColor"
      :class="classBar"
    >
      <template v-slot:prepend>
        <v-app-bar-nav-icon
          class="d-flex d-sm-none"
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <v-app-bar-title
          class="text-center text-h5 font-weight-bold d-none d-sm-flex"
          >SIBANGKOM<br />
          ASN
        </v-app-bar-title>

        <v-tabs active-class="custom-active-tab" class="d-none d-sm-flex">
          <v-tab
            v-for="m in menu"
            :key="m.name"
            :to="m.link"
            :color="color"
            style="font-size: 15px"
            class="px-5 text-capitalize text-white"
            >{{ m.name }}</v-tab
          >
        </v-tabs>
      </template>

      <template v-slot:append>
        <h4 v-if="useUserStore().loggedIn" class="mr-3">
          Hi, {{ useUserStore().user.firstName.split(" ")[0] }}
        </h4>

        <NotifIcon v-if="useUserStore().loggedIn" />
        <UserProfile v-if="useUserStore().loggedIn" />

        <v-btn
          v-else
          to="/login"
          class="font-weight-bold bg-white"
          color="primary"
          rounded
          size="large"
        >
          <template v-slot:prepend>
            <v-icon size="40" class="text-primary">mdi-login</v-icon>
          </template>
          Login
        </v-btn>
      </template>
    </v-app-bar>

    <v-main class="bg-grey-lighten-3">
      <NuxtPage />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    tab: null,
    appBarColor: "primary",
    classBar: "white",
    nameLogo: "./images/logo.png",
    color: "white",
    items: [],
    menu: [
      { name: "Home", link: "/" },
      { name: "Pelatihan", link: "/RiwayatPelatihan" },
      { name: "Pembelajaran", link: "/TanyaJawab" },
      { name: "Pengelolaan", link: "/Panduan" },
      { name: "Pembinaan", link: "/DasarHukum" },
      { name: "inovasi", link: "/DasarHukum" },
      { name: "Pusat Bantuan", link: "/pusat-bantuan" },
    ],
  }),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY;
      if (scrollY > 100) {
        this.appBarColor = "primary";
        this.classBar = "elevation-4";
        (this.nameLogo = "./images/logowhite.png"), (this.color = "white");
      } else {
        this.appBarColor = "primary";
        this.classBar = "elevation-0";
        this.nameLogo = "./images/logo.png";
        this.color = "white";
      }
    },
  },
};
</script>

<style>
/* Global blue theme for landing layout */
:root {
  --color-primary: #3781c8;
  --color-primary-dark: #15578d;
  --color-accent-yellow: #f2bd1d;
}

/* Override Vuetify's primary colors globally in landing layout */
.v-theme--light {
  --v-theme-primary: 55, 129, 200 !important; /* #3781c8 in RGB */
}

.bg-primary {
  background-color: var(--color-primary) !important;
}

.text-primary {
  color: var(--color-primary) !important;
}

/* Active tab styling for the new blue theme */
.custom-active-tab {
  background-color: var(--color-primary-dark) !important;
  color: white !important;
}
</style>
